export const GRAVITY_PX_S2 = 5200;
export const JUMP_DUR_MS = 460;
export const MAX_DT_S = 0.05;
export const DROP_SETTLE_MS = 90;
export const PAUSE_POLL_MS = 250;
export const ARRIVE_EPS = 1.5;
export const STRIDE_PER_LOOP = 0.8;

const easeOutCubic = (t: number): number => 1 - (1 - t) ** 3;

/** A backgrounded tab can hand back a multi-second delta; integrating it whole
 *  would teleport the companion across the workspace. */
export const clampDt = (dtSeconds: number): number =>
  Math.min(MAX_DT_S, Math.max(0, dtSeconds));

/** Derive walk speed from the sprite's own loop so the feet sync to the
 *  animation instead of gliding. */
export const walkSpeedPxS = (displayWidth: number, loopMs: number): number =>
  (displayWidth * STRIDE_PER_LOOP) / (loopMs / 1000);

export function stepFall(y: number, velocity: number, dt: number): { y: number; velocity: number } {
  const nextVelocity = velocity + GRAVITY_PX_S2 * dt;
  return { y: y + nextVelocity * dt, velocity: nextVelocity };
}

export function stepJump(fromY: number, toY: number, elapsedMs: number): { y: number; done: boolean } {
  const t = Math.min(1, elapsedMs / JUMP_DUR_MS);
  return { y: fromY + (toY - fromY) * easeOutCubic(t), done: t >= 1 };
}

export function stepWalk(
  x: number,
  targetX: number,
  speedPxS: number,
  dt: number,
): { x: number; arrived: boolean } {
  const remaining = targetX - x;
  if (Math.abs(remaining) <= ARRIVE_EPS) return { x: targetX, arrived: true };

  const step = speedPxS * dt;
  if (step >= Math.abs(remaining)) return { x: targetX, arrived: true };

  return { x: x + Math.sign(remaining) * step, arrived: false };
}
